import { gql } from '@/__generated__/gql';

export const INVESTOR_DETAILS_LEGAL_ENTITY_ASSET_CLASS_TARGETS_QUERY = gql(`
  query InvestorDetailsLegalEntityAssetClassTargets($id: String!, $assetClassTargetsInput: AssetClassTargetQueryInput) {
    legalEntity(id: $id) {
      targetOCRatio
      ignoreBiteSize
      ignoreAllocationTargets
      assetClassTargets(input: $assetClassTargetsInput) {
        id
        name
        percentage
        targetAllocation
        economicExposure
        capacity
        currentNAV
        unfundedCommitments
        illiquid
        pacingTarget {
          startDate
          cumulativePacingTarget
          cumulativeCommitments
          remainingPacingTarget
          evergreenCapacity
          pacingTargetThroughDate
        }
        subAssetClasses {
          id
          name
          percentage
          targetAllocation
          economicExposure
          capacity
          currentNAV
          unfundedCommitments
          illiquid
          pacingTarget {
            startDate
            cumulativePacingTarget
            cumulativeCommitments
            remainingPacingTarget
            pacingTargetThroughDate
          }
        }
      }
    }
  }
`);

export const INVESTOR_DETAILS_GROUP_ASSET_CLASS_TARGETS_QUERY = gql(`
  query InvestorDetailsGroupAssetClassTargets($data: GetGroupInput!, $assetClassTargetsInput: AssetClassTargetQueryInput) {
    group(data: $data) {
      id
      targetOCRatio
      ignoreBiteSize
      ignoreAllocationTargets
      assetClassTargets(input: $assetClassTargetsInput) {
        id
        name
        percentage
        targetAllocation
        economicExposure
        capacity
        currentNAV
        unfundedCommitments
        illiquid
        pacingTarget {
          startDate
          cumulativePacingTarget
          cumulativeCommitments
          remainingPacingTarget
          evergreenCapacity
          pacingTargetThroughDate
        }
        subAssetClasses {
          id
          name
          percentage
          targetAllocation
          economicExposure
          capacity
          currentNAV
          unfundedCommitments
          illiquid
          pacingTarget {
            startDate
            cumulativePacingTarget
            cumulativeCommitments
            remainingPacingTarget
            pacingTargetThroughDate
          }
        }
      }
    }
  }
`);

export const INVESTOR_DETAILS_LEGAL_ENTITY_NOTES_QUERY = gql(`
  query InvestorDetailsLegalEntityNotes($id: String!) {
    legalEntity(id: $id) {
      id
      entityName
      onHold
      aboutInvestorNote
      notes {
        date
        note
      }
    }
  }
`);

export const INVESTOR_DETAILS_GROUP_NOTES_QUERY = gql(`
  query InvestorDetailsGroupNotes($data: GetGroupInput!) {
    group(data: $data) {
      id
      name
      onHold
      legalEntities {
        id
        entityName
        aboutInvestorNote
      }
      legalEntityNotes {
        legalEntityId
        name
        notes {
          date
          note
        }
      }
    }
  }
`);

export const INVESTOR_DETAILS_HOUSEHOLD_NOTES_QUERY = gql(`
  query InvestorDetailsHouseholdNotes($data: getInvestorDto!) {
    getInvestor(data: $data) {
      id
      name
      legalEntities {
        id
        entityName
        aboutInvestorNote
        entities {
          id
          entityName
          aboutInvestorNote
        }
      }
      legalEntityNotes {
        legalEntityId
        name
        notes {
          date
          note
        }
      }
    }
  }
`);

export const INVESTOR_DETAILS_UPDATE_LEGAL_ENTITY_NOTES_MUTATION = gql(`
  mutation InvestorDetailsUpdateLegalEntityNotes($data: UpdateLegalEntityNotesInput!) {
    updateLegalEntityNotes(data: $data) {
      id
    }
  }
`);

export const INVESTOR_LEGAL_ENTITIES_QUERY = gql(`
  query InvestorDetailsGetInvestorLegalEntities($data: getInvestorDto!) {
    getInvestor(data: $data) {
      name
      advisor {
        id
        firstName
        lastName
        roles
      }
      legalEntities {
        id
        entityName
        isGroup
        groupId
        entities {
          id
          entityName
          primaryEntity
          groupId
        }
        family {
          id
          name
        }
      }
    }
  }
`);

export const INVESTOR_DETAILS_LIST_ENTITY_TRANSACTIONS_TOTAL_QUERY = gql(`
  query InvestorDetailsListEntityTransactionsTotal($legalEntityIds: [String!]!, $page: Int!, $rowsPerPage: Int!) {
    ListEntityTransactions(legalEntityIds: $legalEntityIds, page: $page, rowsPerPage: $rowsPerPage) {
      total
    }
  }
`);

export const INVESTOR_DETAILS_COMMITMENT_PLANS_TOTAL_QUERY = gql(`
  query InvestorDetailsCommitmentPlansTotal($input: GetCommitmentPlansInput!) {
    commitmentPlans(input: $input) {
      total
    }
  }
`);
